import { render, staticRenderFns } from "./AdminHasPersonalRequests.vue?vue&type=template&id=ca5dd20c&"
import script from "./AdminHasPersonalRequests.vue?vue&type=script&lang=js&"
export * from "./AdminHasPersonalRequests.vue?vue&type=script&lang=js&"
import style0 from "./AdminHasPersonalRequests.vue?vue&type=style&index=0&id=ca5dd20c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports